import { createTheme } from '@mui/material/styles';

const display = "'Bricolage Grotesque', sans-serif";

const theme = createTheme({
  palette: {
    primary: { main: '#13707A', dark: '#0B2E35', light: '#5FA8AE', contrastText: '#ffffff' },
    secondary: { main: '#F2A93B', dark: '#C9841A', contrastText: '#0B2E35' },
    background: { default: '#F4F7F6', paper: '#ffffff' },
    text: { primary: '#10262B', secondary: '#4C6469' },
    divider: '#D5E0DF',
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: "'Figtree', sans-serif",
    h1: { fontFamily: display, fontWeight: 800, letterSpacing: '-0.03em' },
    h2: { fontFamily: display, fontWeight: 800, letterSpacing: '-0.03em' },
    h3: { fontFamily: display, fontWeight: 700, letterSpacing: '-0.02em', fontSize: '2.6rem' },
    h4: { fontFamily: display, fontWeight: 700, letterSpacing: '-0.01em' },
    h5: { fontFamily: display, fontWeight: 700 },
    h6: { fontFamily: display, fontWeight: 700 },
    button: { textTransform: 'none', fontWeight: 700 },
  },
  components: {
    MuiCssBaseline: { styleOverrides: { html: { scrollBehavior: 'smooth' } } },
    MuiButton: { styleOverrides: { root: { borderRadius: 4, padding: '12px 26px', fontSize: '1rem' } } },
  },
});

export default theme;
